<div class="modal-header">
    <h4 class="modal-title pull-left">{{isShoVerification ? "Email verification" : "Change Email"}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="cancel()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <div *ngIf="isShoVerification">
        <p>An email with verification code was sent to {{email.value}}.
            <a href="javascript:;" (click)="sendVerificationNumber(true)" [class.disable]="isOtpSending">{{isOtpSending
                ?
                'Sending...':'Resend code' }}</a>
        </p>
    </div>
    <form [formGroup]="form">
        <div class="form-group mb-0">
            <input type="text" class="form-control" placeholder="Enter New Email" formControlName="email"
                [ngClass]="{ 'is-invalid': isSubmitted && f.email.errors }" [hidden]="isShoVerification">
            <div *ngIf="isSubmitted && f.email.errors" class="invalid-feedback">
                <div *ngIf="f.email.errors.required">Email is required</div>
                <div *ngIf="f.email.errors.notValid">{{errorMsg}}</div>
            </div>
            <input type="text" class="form-control" placeholder="Enter Verification code" formControlName="code"
                [ngClass]="{ 'is-invalid': isSubmitted && f.code.errors }" *ngIf="isShoVerification">
            <div *ngIf="isSubmitted && f.code.errors" class="invalid-feedback">
                <div *ngIf="f.code.errors.required">In valid verification code</div>
                <div *ngIf="f.code.errors.notValid">{{errorMsg}}</div>
            </div>
        </div>
        <div class="form-group" *ngIf="isShoVerification">
            <small class="text-muted">Code Expires in {{time}} seconds</small>
        </div>
    </form>
</div>

<div class="modal-footer">
    <div *ngIf="form.enabled">
        <button class="btn btn-light mr-2" (click)="cancel();">Cancel</button>
        <am-button (onClicked)="sendVerificationNumber()" [text]="'Update'" *ngIf="!isShoVerification"
            [isLoading]="isButtonDisabled"></am-button>
        <am-button (onClicked)="submitForm()" [text]="'Validate'" *ngIf="isShoVerification"
            [isLoading]="isButtonDisabled"></am-button>
    </div>
</div>